import useSWR from "swr";

import { useApiAccess } from "./useApiAccess";
import { getSubcategories } from "../../Service/CategoryService";
import { apiRoutes } from "../../Constants/ApiRoutes";

export const useSubCategories = ({ categorySlug }) => {
    const hasAccess = useApiAccess();
    return useSWR(
        hasAccess && categorySlug ? `${apiRoutes.subCategories}${categorySlug}` : null,
        () => getSubcategories({ categorySlug })
    );
};